export enum TaskType {
  NONE = 'none',
  VM = 'vm',
  DOWNLOADABLE = 'downloadable',
  THM = 'THM',
  STATIC_SITE = 'static-site',
  AZURE = 'azure',
}
